<script context="module" lang="ts">
	import WYSIWYG from './../components/inputs/WYSIWYG.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';
	import Section from '$lib/components/layout/Section.svelte';

	export const config: SectionConfig = {
		collection: 'section_legal',
		availableFor: ['pages', 'special-pages'],
		query: gql`
        translations {
				languages_code {
					code
				}
				title
				text
        content
			}
      `
	};

	// optional: define a type for the props (note: injectTranslations is applied)
	type Props = {
		title: string;
		text: string;
		content: any;
	};
</script>

<script lang="ts">
	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)
</script>

<Section type="slim" gapType="padding">
	<div class="legal-wrapper">
		{#if data.title}
			<div class="legal-title">{data.title}</div>
		{/if}
		{#if data.text}
			<WYSIWYG text={data.text} />
		{/if}
		{#if data.content}
			{#each data.content as item}
				<div class="content-wrapper">
					<div class="content-title">{item.title}</div>
					<div class="content-text">
						<WYSIWYG text={item.text} />
					</div>
				</div>
			{/each}
		{/if}
	</div>
</Section>

<style lang="scss">
	.legal-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--content-gap-xl);
		:global(a) {
			color: color(yellow);
		}
	}
	.legal-title {
		@include font(h1);
		border-bottom: solid 1px color(black);
	}
	.content-wrapper {
		display: grid;
		grid-template-columns: 400px auto;
		gap: var(--content-gap-lg);
		grid-template-columns: minmax(auto, 25ch) auto;
		grid-gap: var(--content-gap);
		word-break: break-word;

		@include media(tablet) {
			grid-template-columns: 1fr;
		}
	}
	.content-title {
		font-weight: bold;
	}
</style>
